<div class="col-12 ">
  <div class=" loader"></div>
</div>
